console.log('commission.model.js: Model exporting');
module.exports = {
  name: 'Commission',
  gen_template: `
    {
      "ref_no": "{{random.alphaNumeric}}{{random.number}}{{random.alphaNumeric}}{{random.number}}",
      "class_of_business": "{{lorem.word}}",
      "commission_rate": {{random.number({ min: 1, max: 100 })}}
    }
  `,
  wizard: {
    add_commission: {
      actionBtn: 'Save',
      action: 'add_commission',
      pages: [
        {
          title: 'Commission',
          subtitle: 'Configure new commission',
          forms: [
            {
              type: 'text', form_type: 'text', label: 'Ref No', model: 'ref_no',
              validation: 'required|min:1|max:50', class: 'col-12 col-md-6'
            },
            {
              type: 'text', form_type: 'text', label: 'Class of Business', model: 'class_of_business',
              validation: 'required|min:3|max:150', class: 'col-12 col-md-6'
            },
            {
              type: 'text', form_type: 'text', label: 'Commission Rate (%)', model: 'commission_rate',
              validation: 'required|numeric|min:0|max:100', class: 'col-12 col-md-6'
            }
          ],
        }
      ],
    },
  },
  table: {
    title: 'Commissions',
    subtitle: 'A list of configured commissions',
    table_fields: [
      { name: 'Ref No', align: 'l' },
      { name: 'Class of Business', align: 'l' },
      { name: 'Commission Rate (%)', align: 'l' },
      { name: 'actions', align: 'c' }
    ],
    searchFields: ['ref_no', 'class_of_business', 'commission_rate'],
    rowData: [
      { type: 'text', field: 'ref_no', class: 'left small' },
      { type: 'text', field: 'class_of_business', class: 'left bolder' },
      { type: 'text', field: 'commission_rate', class: 'left bolder small' },
      {
        type: 'action', field: 'class_of_business', class: 'center', icon: '', actions: [
          {
            type: 'menu', title: 'Edit', event: 'commission:edit', icon: 'ico-right', params: [
              { key: 'commission', field: '*' }
            ]
          },
          {
            type: 'menu', title: 'View', event: 'commission:view', icon: 'ico-reply', params: [
              { key: 'commission', field: '*' }
            ]
          },
        ]
      },
    ]
  },
};